import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h24v24H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4285f4",
			d: "M19.432 12.179c0-.558-.05-1.095-.14-1.61H12v3.049h4.166a3.63 3.63 0 0 1-1.555 2.369v1.983h2.513c1.463-1.374 2.308-3.393 2.308-5.791"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#34a853",
			d: "M12 19.874c2.09 0 3.843-.701 5.124-1.904l-2.513-1.983c-.69.473-1.57.759-2.611.759-2.013 0-3.723-1.382-4.335-3.243H5.089v2.033c1.273 2.57 3.885 4.338 6.911 4.338"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fbbc05",
			d: "M7.665 13.496c-.155-.472-.247-.973-.247-1.496s.092-1.024.247-1.496V8.471H5.089c-.528 1.06-.831 2.255-.831 3.529s.303 2.47.83 3.529l2.006-1.59z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ea4335",
			d: "M12 7.261c1.14 0 2.154.401 2.963 1.174L17.18 6.18C15.836 4.907 14.09 4.127 12 4.127c-3.026 0-5.638 1.768-6.911 4.345l2.575 2.033C8.278 8.643 9.988 7.26 12 7.26"
		})
	]
});
export default SvgGoogle;
